import "../styles/FullscreenLoader.css";

export default function FullscreenLoader({
  title = "Carregando",
  message = "Aguarde um instante...",
}) {
  return (
    <div
      className="fsLoaderOverlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="fsLoaderCard">
        <div className="fsLoaderWave" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <div className="fsLoaderTitle">{title}</div>
        <div className="fsLoaderText">{message}</div>
      </div>
    </div>
  );
}
